<template>
  <BModalForm
    ref="modal"
    v-bind="$attrs"
    :create-default-data="createDefaultData"
    :transform-data="transformData"
    :save-menu-list="saveMenuList"
    :max-width="hasUsers ? '900px' : '680px'"
    @closed="$emit('closed')"
  >
    <template #title-text="{ editable, viewOnly, form }">
      {{ getTitle(editable || viewOnly, form) }}
    </template>

    <template #default="{ editable, viewOnly, form }">
      <PublicationStorageFilesForm
        :form="form"
        :has-users="hasUsers"
        :storage="storage"
        :disabled="editable || viewOnly"
        :unzip.sync="unzip"
      />
    </template>
  </BModalForm>
</template>

<script>
import { SAVE_MENUS } from '@/components/common/BFormButtons.vue'
import { PublicationStorageFileModel as Model } from '../Model'

import BModalForm from '@/components/modals/BModalForm.vue'
import PublicationStorageFilesForm, { createDefaultData } from './PublicationStorageFilesForm.vue'


export default {
  name: 'PublicationStorageFilesModal',
  inject: ['$validator'],
  components: {
    BModalForm,
    PublicationStorageFilesForm,
  },
  inheritAttrs: false,
  props: {
    storage: {
      type: Object,
      required: true,
      validator: (prop) => (
        prop
        && 'start_at' in prop
        && 'end_at' in prop
        && 'storage_type' in prop
      ),
    },
    publication: {
      type: Object,
      required: true,
      validator: (prop) => (
        prop
        && 'participants' in prop
      ),
    },
    publication_id: {
      type: [String, Number],
      required: true,
    },
    storage_id: {
      type: [String, Number],
      required: true,
    },
    hasUsers: {
      type: Boolean,
      required: true,
    },
  },
  data: (vm) => ({
    unzip: false,
    createDefaultData: () => createDefaultData(
      vm.storage.start_at,
      vm.storage.end_at,
      vm.storage.storage_type,
    ),
  }),
  computed: {
    saveMenuList() {
      return this.unzip ? [
        SAVE_MENUS.SAVE,
        SAVE_MENUS.SAVE_MORE,
      ] : [
        SAVE_MENUS.SAVE,
        SAVE_MENUS.SAVE_CONTINUE,
        SAVE_MENUS.SAVE_MORE,
      ]
    },
  },
  methods: {
    open() {
      return this.$refs.modal.open()
    },
    close() {
      return this.$refs.modal.close()
    },
    getTitle(editable, form) {
      if (editable) return Model.page_title.view({ name: form.filename })
      return form.id ? Model.page_title.edit : Model.page_title.create
    },
    transformData(data) {
      return {
        ...data,

        file: data.file.id ? void 0 : data.file,
        users: void 0,
        user_ids: data.users.map((_) => _.id),
        ...(data.unzip ? {} : (function () {
          const posRaw = data.position
          if (posRaw === null || posRaw === undefined || posRaw === '') return {}
          const num = Math.trunc(Number(posRaw))
          if (Number.isNaN(num)) return {}
          const clamped = Math.min(100000, Math.max(1, num))
          return { position: clamped }
        }())),
      }
    },
  },
}
</script>
